import { memo } from 'react';

type NotificationCustomFieldTextValueProps = {
  value: string;
};

export const NotificationCustomFieldTextValue = memo(({ value }: NotificationCustomFieldTextValueProps) => {
  return <p className="rounded-4 bg-grey-4 px-1 font-medium text-12 text-grey-12">{value}</p>;
});

NotificationCustomFieldTextValue.displayName = 'NotificationCustomFieldTextValue';
